import React, { useMemo } from 'react';
import { Stack, useFocusIdx } from 'easy-email-editor';
import { RadioGroupField } from '../../../components/Form';

const options = [
  {
    value: 'left',
    label: 'Лево',
  },
  {
    value: 'center',
    label: 'Центр',
  },
  {
    value: 'right',
    label: 'Право',
  },
];

export function Align({ inline }: { inline?: boolean }) {
  const { focusIdx } = useFocusIdx();

  return (
    <RadioGroupField
      label='Выравнивание'
      name={`${focusIdx}.attributes.align`}
      options={options}
    />
  );
}
